module.exports = __webpack_public_path__ + "static/media/signin-bg.aab67210.svg";